import React from 'react';
import { HorizontalRuleOutlined } from '@mui/icons-material';
import { Divider, DividerPropsSchema } from './Divider';
import DividerSidebarPanel from './DividerSidebarPanel';
export default {
    label: 'Divider',
    icon: React.createElement(HorizontalRuleOutlined, null),
    type: 'Divider',
    defaultData: {
        style: { padding: { top: 16, right: 0, bottom: 16, left: 0 } },
        props: {
            lineHeight: 1,
            lineColor: '#333333',
        },
    },
    SidebarPanel: DividerSidebarPanel,
    Component: Divider,
    schema: DividerPropsSchema,
};
//# sourceMappingURL=index.js.map